import {ControllerFlowAPI, IWixAPI, StructurePage} from '@wix/yoshi-flow-editor'
import {MembersSettings, MembersTexts} from '../../../../commons/enums'
import * as navigation from '../../../../commons/services/navigation'
import settingsParams from '../../settingsParams'
import {MemberPageState} from '../types/state'

export const getUserText = (state: MemberPageState, key: MembersTexts) => state.component.settings.texts[key]
export const getSetting = (state: MemberPageState, key: MembersSettings) => state.component.settings[key]

interface GetNoEventsPageArgs {
  wixCodeApi: IWixAPI
  state: MemberPageState
  flowAPI: ControllerFlowAPI
}

export const getNoEventsPage = async ({wixCodeApi, flowAPI, state}: GetNoEventsPageArgs): Promise<StructurePage> => {
  const pageId =
    (flowAPI.settings.get(settingsParams.noUpcomingEventsLinkPageId) as string) ??
    getSetting(state, MembersSettings.noUpcomingEventsLinkPageId)
  let page = pageId && (await navigation.getPage(wixCodeApi, pageId))
  page = page ? page : await navigation.getHomePage(wixCodeApi)
  return page
}
